import { Tokens } from '@/assets/tokens'
import { ChangeEvent } from 'react'
import styled from 'styled-components'
import { Advice } from '../../key-message/KeyMessage.styles'

interface GlobalPriorityRulesProps {
  firstStageRules: string
  secondStageRules: string
  onFirstStageRulesChange: (value: string) => void
  onSecondStageRulesChange: (value: string) => void
}

const GlobalRulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 8px;
  padding: 24px;
  background-color: ${Tokens.ColorBackground};
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 12px;
`

const GlobalRulesTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

const GlobalRulesSubtitle = styled.p`
  margin: 0 0 16px 0;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  line-height: 1.5;
`

const StageSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`

const StageTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

const RulesTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  max-height: 200px;
  padding: 12px;
  border: 1px solid #dee2ef;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  overflow-y: auto;

  &:focus {
    outline: none;
    border-color: #01c38d;
  }

  &::placeholder {
    color: #9ca3af;
  }
`

export function GlobalPriorityRules({
  firstStageRules,
  secondStageRules,
  onFirstStageRulesChange,
  onSecondStageRulesChange,
}: GlobalPriorityRulesProps): JSX.Element {
  const handleFirstStageChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onFirstStageRulesChange(e.target.value)
  }

  const handleSecondStageChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onSecondStageRulesChange(e.target.value)
  }

  return (
    <GlobalRulesContainer>
      <div>
        <GlobalRulesTitle>
          Lógica de Classificação e Contexto <Advice>(opcional)</Advice>
        </GlobalRulesTitle>
        <GlobalRulesSubtitle>
          Instrua a IA sobre como interpretar ambiguidades, aplicar o contexto do cliente e realizar o raciocínio lógico
          antes de definir cada classificação.
        </GlobalRulesSubtitle>
      </div>

      <StageSection>
        <StageTitle>Primeira Etapa (positivo, negativo, neutro)</StageTitle>
        <RulesTextArea
          placeholder="Digite as regras de prioridade para a primeira etapa de classificação..."
          value={firstStageRules}
          onChange={handleFirstStageChange}
        />
      </StageSection>

      <StageSection>
        <StageTitle>Segunda Etapa (favorável, desfavorável)</StageTitle>
        <RulesTextArea
          placeholder="Digite as regras de prioridade para a segunda etapa de classificação..."
          value={secondStageRules}
          onChange={handleSecondStageChange}
        />
      </StageSection>
    </GlobalRulesContainer>
  )
}
